import React from "react";
import cn from "classnames";
import { FormControl, FormLabel } from "@material-ui/core";
import type { FC } from "react";
import { useBulkCalendarControl } from "./BulkCalendarControl.state";
import { useStyles } from "./BulkCalendarControl.styles";
import { DateRangeGroup } from "./DateRangeGroup";
import { LatestAvailableValue } from "./LatestAvailableValue";
import type { IBulkCalendarControlProps } from "./BulkCalendarControl.types";

export const BulkCalendarControl: FC<IBulkCalendarControlProps> = <T extends number | string | unknown = unknown>(props) => {
  const classes = useStyles();
  const {
    state,
    onChangeCheckedHander,
    onChangeCountLastItemHander,
    onChangeFromHander,
    onChangeToHander,
    onChangeLatestAvailableValueHander,
  } = useBulkCalendarControl<T>(props);

  const label = "Select date range";
  const disabled = state.availableDateRanges.every((dateRange) => !state.items[dateRange].length);
  const hiddenCheckbox = state.availableDateRanges.length === 1;

  return (
    <div className={classes.root}>
      <FormControl component="fieldset" className={cn({ [classes.formControl]: true })}>
        <FormLabel component="legend" className={classes.label}>
          {label}
        </FormLabel>

        {state.availableDateRanges.map((dateRange) => {
          const checked = state.selectedRanges.includes(dateRange);
          const items = state.items[dateRange]!;
          const from = state.from[dateRange];
          const to = state.to[dateRange];
          const countLastItem = state.countLastItem[dateRange];

          const handleChangeCountLastItem = (count: number) => onChangeCountLastItemHander(dateRange, count);
          const handleChangeChecked = (checked: boolean) => onChangeCheckedHander(dateRange, checked);
          const handleChangeFrom = (value: T) => onChangeFromHander(dateRange, value);
          const handleChangeTo = (value: T) => onChangeToHander(dateRange, value);
          return (
            <DateRangeGroup
              key={dateRange}
              dateRange={dateRange}
              checked={checked}
              items={items}
              from={from}
              onChangeFrom={handleChangeFrom}
              to={to}
              onChangeTo={handleChangeTo}
              countLastItem={countLastItem ?? 1}
              onChangeCountLastItem={handleChangeCountLastItem}
              onChangeChecked={handleChangeChecked}
              hiddenCheckbox={hiddenCheckbox}
            />
          );
        })}
        <LatestAvailableValue disabled={disabled} checked={state.latestAvailableValue} onChange={onChangeLatestAvailableValueHander} />
      </FormControl>
    </div>
  );
};
